/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a data size between bytes, KB, MB, GB, TB and the binary KiB, MiB, GiB, TiB units — all at once.`)
};

const es_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un tamaño de datos entre bytes, KB, MB, GB, TB y las unidades binarias KiB, MiB, GiB, TiB — todo de una vez.`)
};

const de_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnen Sie eine Datengröße zwischen Byte, KB, MB, GB, TB und den binären Einheiten KiB, MiB, GiB, TiB um — alle gleichzeitig.`)
};

const nl_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer een gegevensgrootte tussen bytes, KB, MB, GB, TB en de binaire KiB, MiB, GiB, TiB-eenheden — allemaal tegelijk.`)
};

const fr_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez une taille de données entre les octets, KB, MB, GB, TB et les unités binaires KiB, MiB, GiB, TiB — tout à la fois.`)
};

const it_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti una dimensione dei dati tra B, KB, MB, GB, TB e le unità binarie KiB, MiB, GiB, TiB — tutto in una volta.`)
};

const pt_br2_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um tamanho de dados entre bytes, KB, MB, GB, TB e as unidades binárias KiB, MiB, GiB, TiB — tudo de uma só vez.`)
};

const pt_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um tamanho de dados entre bytes, KB, MB, GB, TB e as unidades binárias KiB, MiB, GiB, TiB — tudo de uma vez.`)
};

const ja_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト、KB、MB、GB、TBおよびバイナリユニットKiB、MiB、GiB、TiBの間でデータサイズを一度に変換します。`)
};

const zh_ds_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在字节、KB、MB、GB、TB 以及二进制的 KiB、MiB、GiB、TiB 单位之间一次性换算数据大小。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_intro", locale)
	if (locale === "en") return en_ds_intro(inputs)
	if (locale === "es") return es_ds_intro(inputs)
	if (locale === "de") return de_ds_intro(inputs)
	if (locale === "nl") return nl_ds_intro(inputs)
	if (locale === "fr") return fr_ds_intro(inputs)
	if (locale === "it") return it_ds_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ds_intro(inputs)
	if (locale === "pt") return pt_ds_intro(inputs)
	if (locale === "ja") return ja_ds_intro(inputs)
	return zh_ds_intro(inputs)
};